<template>

  <div class="PrefabCreater_Options" style="min-height: 200px">

    <div class="PrefabCreator_SelectorsBtns ss" v-on:scroll.passive="scrollTopMenu" ref="PrefabCreator_SelectorsBtns"
         id="PrefabCreator_SelectorsBtns" @mouseover="handleMouseOver"
         @mouseleave="handleMouseLeave">
      <div v-for="(cat,ind) in  SubCategories" :key="cat.ID">
        <span :id="'anchor_'+cat.category_nr" class="prefab_anchor"></span>
        <div class="PrefabCreator_CurrentCategory" :class="ind === 0 ? 'firstCatOnList' : ''">
          <span class="CatTitle">{{ cat.title_swe }}</span>
          <div class="CurrentCategoryStepsHolder">
            <div class="stepsHolder">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.875 4.90149V11.0975C14.875 11.1689 14.8548 11.239 14.8163 11.3006C14.7778 11.3621 14.7225 11.4128 14.6561 11.4475L8.70613 14.5582C8.64305 14.5911 8.57212 14.6083 8.5 14.6083C8.42788 14.6083 8.35694 14.5911 8.29387 14.5582L2.34388 11.4475C2.27752 11.4128 2.22222 11.3621 2.18373 11.3006C2.14524 11.239 2.12496 11.1689 2.125 11.0975V4.90149C2.12509 4.83018 2.14543 4.7602 2.18391 4.69878C2.22239 4.63736 2.27762 4.58673 2.34388 4.55215L8.29387 1.44082C8.35694 1.4079 8.42788 1.39062 8.5 1.39062C8.57212 1.39062 8.64305 1.4079 8.70613 1.44082L14.6561 4.55215C14.7224 4.58673 14.7776 4.63736 14.8161 4.69878C14.8546 4.7602 14.8749 4.83018 14.875 4.90149Z"
                    stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M2.49854 4.86418L8.2927 7.89352C8.35586 7.92656 8.42692 7.9439 8.49918 7.9439C8.57144 7.9439 8.6425 7.92656 8.70566 7.89352L14.5204 4.85352M8.49954 14.0015V8.00152"
                    stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M8.28112 7.88679L2.75613 4.99746C2.69141 4.96368 2.61845 4.94639 2.54445 4.9473C2.47046 4.94821 2.398 4.96728 2.33425 5.00264C2.27049 5.038 2.21765 5.08841 2.18095 5.14889C2.14425 5.20936 2.12496 5.27781 2.125 5.34746V11.0988C2.12496 11.1702 2.14524 11.2403 2.18373 11.3019C2.22222 11.3634 2.27752 11.4142 2.34388 11.4488L7.86888 14.3375C7.93359 14.3712 8.00655 14.3885 8.08054 14.3876C8.15454 14.3867 8.227 14.3676 8.29075 14.3323C8.35451 14.2969 8.40735 14.2465 8.44405 14.186C8.48075 14.1256 8.50004 14.0571 8.5 13.9875V8.23613C8.49991 8.16482 8.47957 8.09484 8.44109 8.03342C8.40261 7.972 8.34738 7.92138 8.28112 7.88679Z"
                    fill="#F7D046" stroke="#061B3A" stroke-linejoin="round"/>
              </svg>
              <span><span class="currentStep">{{ ind + 1 }}</span>/{{ SubCategories.length }}</span>
            </div>
          </div>
          <div style="background-color: #EDEDED;height: 1px;flex: 1"></div>
        </div>
        <div class="d-flex flex-wrap ConfiguratorSelectBoxHolder">
          <div class="ConfiguratorSelectBox " v-for="article in LinkedArticles(cat)" :key="article.article.article_nr"
               :class="activeArticle(article,ind)"
          >
            <div class="ConfiguratorSelectBox_titlePriceHolder"
                 @click="commit_row(article)">
              <i class="icon-checkbox"></i>
              <div style="flex: 1">
                <div class="title">{{ article.article.title }}</div>
                <div class="price">{{ formatNum(parseFloat(article.article.out_price_ex_sek) * 1.25) }} {{ $t('valuta') }}</div>
              </div>
            </div>
            <div class="ConfiguratorSelectBox_ImageHolder">
              <img
                  @click="ShowSelectedDecription(article)"
                  class=""
                  :src="article.article.image ? article.article.image : 'https://husverket.se/wp-content/themes/husverket/assets/images/logo.svg'"
                  alt="">
            </div>
          </div>
        </div>
      </div>
      <div >
        <span :id="'anchor_kassa'" class="prefab_anchor"></span>
        <kassa style="margin-top: 20px"/>
      </div>

    </div>
  </div>

</template>

<script>
import kassa from "@/components/Kassa";
export default {
  name: "SelectorsBtns",
components:{kassa},

  methods: {
    handleMouseOver() {
      // Add logic to handle mouse over
      console.log('Mouse over');
      this.$refs.PrefabCreator_SelectorsBtns.addEventListener('scroll', this.scrollTopMenu);
    },
    handleMouseLeave() {
      // Add logic to handle mouse leave
      console.log('Mouse leave');
      this.$refs.PrefabCreator_SelectorsBtns.removeEventListener('scroll', this.scrollTopMenu);
    },
    scrollTopMenu(e) {
      e.stopPropagation();
      const anchors = document.querySelectorAll('.prefab_anchor');

      for (let i = anchors.length - 1; i >= 0; i--) {
        const anchor = anchors[i];
        const rect = anchor.getBoundingClientRect();

        if (rect.top - 200 <= 0) {
          // Extract the xxx value from the anchor id
          this.currentXxxValue = anchor.id.split('_')[1];
          break;
        }
      }
      console.log(this.currentXxxValue)
      if (this.currentXxxValue !== undefined && this.currentXxxValue !== 'kassa' && this.CurrentCategory.category_nr !== this.currentXxxValue) {
        let cat = this.SubCategories.find(x => x.category_nr === this.currentXxxValue)
        if (cat !== undefined) {
          this.$store.commit('commit_current_view', cat.category_nr)
          this.$store.commit('commit_current_category', cat)
        }
      }
      if(this.currentXxxValue === 'kassa'){
        this.$store.commit('commit_current_view', 'kassa')
      }


    },
    scrollTopMenu_(e) {
      e.stopPropagation();

      const anchors = this.anchors;
      const links = this.links;
      const scrollTop = window.scrollY;
      console.log(anchors)
      anchors.forEach((anchor, index) => {
        const computedStyle = window.getComputedStyle(anchor);


        if (computedStyle.display !== 'none') {
          const thisOffset = anchor.getBoundingClientRect().top + window.scrollY - 200;
          let nextOffset;

          if (index + 1 < anchors.length) {
            nextOffset = anchors[index + 1].getBoundingClientRect().top + window.scrollY - 200;
          } else {
            nextOffset = document.body.scrollHeight;
          }

          if (thisOffset <= scrollTop && nextOffset >= scrollTop) {
            const id = '#' + anchor.id;

            if (!links[index].classList.contains('current')) {
              // Remove 'current' class from all links and add it to the current one

              links.forEach(link => link.classList.remove('current'));
              links[index].classList.add('current');


              const pos = links[index].getBoundingClientRect().left + window.scrollX;
              const elementWidth = links[index].offsetWidth;
              const currentScroll = document.querySelector('#PrefabCreator_topMenu_ul').scrollLeft;
              const divWidth = document.querySelector('#PrefabCreator_topMenu_ul').offsetWidth;

              // Calculate the scroll position
              const scrollPos = pos + currentScroll - divWidth / 2 + elementWidth / 2;

              // Scroll the menu
              document.querySelector('#PrefabCreator_topMenu_ul').scrollLeft = scrollPos;

            }

            // Exit the loop early if a match is found
            return;
          }
        }
      });


    },
    ShowSelectedDecription(article) {
      this.$store.commit('commit_infoArticle', article)
    },
    LinkedArticles(row) {
      // return row.LinkedArticles
      let articles = []
      let self = this
      let new_order_row = this.$store.state.order.rows.map(function (b) {
        return parseInt(b.article.article_nr)
      })
      if (row.LinkedArticles.length > 0) {
        row.LinkedArticles.forEach(function (x) {
          let if_string = x.article.if_string.toString().split(',')
          if_string.forEach(m => {
            if (new_order_row.includes(parseInt(m)) || isNaN(parseInt(m))) {
              articles.push(x)
            }
          })

        })
      }
      if (articles.length <= 0) {
        let CurrentView = this.SubCategories.findIndex(x => x.category_nr === this.CurrentCategory.category_nr)
        if (CurrentView < this.SubCategories) {
          let nextView = this.SubCategories[CurrentView + 1]
          this.$store.commit('commit_current_view', nextView.category_nr)
          this.$store.commit('commit_current_category', nextView)
        }

      }
      return articles

    },
    formatNum(num) {
      num = parseFloat(num)

      // If it is a float, restrict to 2 decimals
      //num = num % 1 !== 0 ? num.toFixed(2) : num.toFixed(0)
      num = Math.round(num).toFixed(0)
      num = num.replace('.', ',')

      return !num ? num : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    activeArticle(e, i) {

      let af = this.$store.state.order.rows.find(x => x.article.article_nr === e.article.article_nr)

      if (af) {
        return 'active'
      }


    },
    commit_row(e) {


      this.$store.commit('closeInfoWindow')
      this.$store.commit('commit_active_row', e)
      this.$store.commit('logic', this.$store.state.layers)

    },

  },
  computed: {

    anchors() {
      return Array.from(document.querySelectorAll('.PrefabCreater_Options .anchor'))
    },
    links() {
      return document.querySelectorAll('#PrefabCreator_topMenu_ul .links_prefab a');
    },
    SubCategories() {
      return this.$store.getters.SubCategories
    },
    CurrentCategory() {
      return this.$store.state.CurrentCategory
    },
    windowHeight() {
      return window.innerHeight - 350
    },
    windowHeight_stage() {
      return window.innerHeight * 0.35
    }
  },

}
</script>

<style lang="scss" scoped>
.PrefabCreater_Options {

  .PrefabCreator_SelectorsBtns {
    padding: 20px 50px 5px 50px;
    @media screen and (max-width: 769px) {
      padding-left: 5px;
      padding-right: 5px;
    }
    overflow-y: scroll;
    gap: 10px;
    display: flex;

    flex-direction: column;
    height: 100%;
    max-height: 100vh; //calc(100vh - 140px);

    &::-webkit-scrollbar {
      display: none;
    }

    .ConfiguratorSelectBoxHolder {
      column-gap: 17px;
      row-gap: 13px;
    }

    .ConfiguratorSelectBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      gap: 10px;
      background: #FFFFFF;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05), 0px 1px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px 1px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      flex: 1 1 48%;
      max-width: 49%;
      @media  screen and (max-width:550px) {
       max-width: 100%;
      }

      &:hover {
        background-color: #F8F8F8;
      }

      &.active {
        background: var(--base-light-green, #F7FCFB);

        i {
          color: #4E9280 !important;
          //transition: all 1s ease-in-out;

          &:before {
            content: '\e947';
          }
        }
      }


      .ConfiguratorSelectBox_titlePriceHolder {
        display: flex;
        flex: 1;
        align-items: center;
        gap: 13px;
        padding: 11px 0 11px 16px;
        i {
          color: #C7C7C7;
          font-size: 26px;
        }

        .title {
          color: var(--gray-black, #000);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 167.188%; /* 26.75px */
          @media screen and (max-width: 791px) {
            font-size: 14px;
          }
        }

        .price {
          color: var(--gray-black, #000);
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 167%; /* 23.38px */
          @media screen and (max-width: 791px) {
            font-size: 12px;
          }

        }
      }
      .ConfiguratorSelectBox_ImageHolder{
        padding: 11px 16px 11px 0;
      }

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid #EDEDED;

      }
    }
  }
}

.PrefabCreator_CurrentCategory {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-family: "DM Sans", sans-serif!important;
  flex-wrap: wrap;

  &:not(.firstCatOnList) {
    margin-top: 33px;
  }

  .CatTitle {
    color: #000;
    font-size: 18px !important;
    font-style: normal;
    font-weight: 500;
    line-height: 147.187%;
    margin-bottom: 0;
    flex: 0;
    min-width: max-content;
    word-break: break-all;
    display: contents;
  }
}

.CurrentCategoryStepsHolder {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .stepsHolder {
    color: var(--gray-09, #8F8F8F);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    display: flex;
    align-items: flex-start;
    gap: 9px;

    .currentStep {
      color: var(--base-blue, #294F8A);
    }
  }

  .InfoBtn {
    border-radius: 14px;
    border: 1px solid var(--gray-06, #E2E2E2);
    background: var(--gray-white, #FFF);
    display: inline-flex;
    padding: 4px 9px 4px 6px;
    align-items: center;
    gap: 10px;
    color: var(--gray-09, #8F8F8F);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    cursor: pointer;

    &:hover {
      background-color: #f7f5f5;
    }
  }
}

</style>
